import Header from './components/Header.jsx'
import Hero from './components/Hero.jsx'
import TrustBar from './components/TrustBar.jsx'
import HowItWorks from './components/HowItWorks.jsx'
import Audiences from './components/Audiences.jsx'
import Comparison from './components/Comparison.jsx'
import Testimonials from './components/Testimonials.jsx'
import CTA from './components/CTA.jsx'
import Footer from './components/Footer.jsx'

export default function App() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <HowItWorks />
        <Audiences />
        <Comparison />
        <Testimonials />
        <CTA />
      </main>
      <Footer />
    </>
  )
}
